export const GRID = 'grid'
export const INLINE = 'inline'
export const FLEX_COL = 'flex-col'
